import { useQuery } from "@tanstack/react-query";
import { route } from "../../../../../../shim/jsbridge";
import { queryOptions } from "../../../../../search/hooks";
import { Analysis, ProcessTree } from "../../../../@types/";
import api from "../../../../api";
import { sampleReportKeys } from "../../../../queryKeys";

const useGetProcessTree = (hash: string, analysis: Analysis) => {
  const endpoint = route(`${analysis}_behavior_processtree`, [hash]);

  const { isPending, data } = useQuery({
    ...queryOptions,
    queryKey: sampleReportKeys.processTree(endpoint),
    queryFn: () => api.getDynamicAnalysisData<ProcessTree>(endpoint),
    select: ({ data: processTreeData }) => processTreeData
  });

  return { isLoading: isPending, data };
};

export default useGetProcessTree;
